import React from 'react';
import { NavLink } from 'react-router-dom';
import './PanelNavbar.css';

const PanelNavbar = () => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');

    return (
        <div className="panel-navbar">
            <div className="container">
                <div className="panel-nav-container">
                    <div className="panel-nav-links">
                        <NavLink 
                            to="/dashboard" 
                            className={({ isActive }) => `panel-nav-link ${isActive ? 'active' : ''}`}
                        >
                            Dashboard
                        </NavLink>
                        <NavLink 
                            to="/appointments" 
                            className={({ isActive }) => `panel-nav-link ${isActive ? 'active' : ''}`}
                        >
                            Appointments
                        </NavLink>
                        <NavLink 
                            to="/doctors" 
                            className={({ isActive }) => `panel-nav-link ${isActive ? 'active' : ''}`}
                        >
                            Doctors
                        </NavLink>
{/*                        
                        <NavLink 
                            to="/patient-details" 
                            className={({ isActive }) => `panel-nav-link ${isActive ? 'active' : ''}`}
                        >
                            Patient Details
                        </NavLink>
*/}                        
                    </div>
                    <div className="panel-user-info">
                        <span className="panel-user-name">
                            👋 Welcome, {user.fullname || 'User'}
                        </span>
                        <button 
                            className="panel-logout-btn"
                            onClick={() => {
                                localStorage.removeItem('token');
                                localStorage.removeItem('user');
                                window.location.href = '/doctors-admin-panel';
                            }}
                        >
                            Logout
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PanelNavbar;